import { FC, memo, useCallback, useEffect, useState } from 'react';
import { Radio } from 'antd';
import Icon from '@ant-design/icons';
import { CircleRadioGroupProps, TRadioItem } from './CircleRadioGroup.types';
import styles from './CircleRadioGroup.module.scss';
import MaleSvg from '../../public/icon/Male.svg';
import FemaleSvg from '../../public/icon/Female.svg';
import NonSmokeSvg from '../../public/icon/NonSmoke.svg';
import SmokeSvg from '../../public/icon/Smoke.svg';
import { useQuoteCardMobile } from '@/hooks/use-quote-card-mobile';

const map = {
  Gender: [
    { icon: MaleSvg, value: 'M' },
    { icon: FemaleSvg, value: 'F' }
  ],
  Smoke: [
    { icon: NonSmokeSvg, value: 'false' },
    { icon: SmokeSvg, value: 'true' }
  ]
};

const CircleRadioGroup = memo((props: CircleRadioGroupProps) => {
  const { type } = props;
  const radioGroup = map[type];
  const isMobile = useQuoteCardMobile();

  const iconSize = isMobile ? '25px' : '32px';
  const radioSize = isMobile ? '44px' : '56px';

  return (
    <div className={styles.radio_group}>
      <Radio.Group onChange={props.onChange} value={props.value}>
        {radioGroup.map((item: TRadioItem, index: any) => {
          return (
            <Radio value={item.value} style={{ width: radioSize, height: radioSize }} key={index}>
              <Icon className={styles.Icon} style={{ fontSize: iconSize }} component={item.icon} />
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );
});
export default CircleRadioGroup;
